import React, {useContext, createContext, useState, useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import {CookieStorage} from '@salesforce/commerce-sdk-react/auth/storage'
import {onClient} from '@salesforce/commerce-sdk-react/utils'
import {useStores} from '@salesforce/commerce-sdk-react'

import SelectStoreModal from '../components/select-store-modal'

export const StoreContext = createContext()
export const useStoreContext = () => useContext(StoreContext) || {}

export const StoreProvider = ({children}) => {
    const value = useStoreProvider()

    return (
        <StoreContext.Provider value={value}>
            {children}
            <SelectStoreModal />
        </StoreContext.Provider>
    )
}

StoreProvider.propTypes = {
    children: PropTypes.node.isRequired
}

const useStoreProvider = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [store, setStore] = useState(null)
    const [refreshBopisCart, setRefreshBopisCart] = useState(false)
    const [cookieStore, setCookieStore] = useState(null)

    const cookie =
        onClient() &&
        new CookieStorage({
            keySuffix: '',
            sharedContext: !onClient()
        })

    const {data: searchStore, isLoading} = useStores({
        parameters: {
            ids: cookieStore
        },
        options: {
            enabled: !!cookieStore
        }
    })

    useEffect(() => {
        setCookieStore(cookie.get('dw_store'))
    }, [])

    useEffect(() => {
        if (searchStore && searchStore?.data?.length > 0) {
            setStore({...searchStore.data[0], ID: searchStore.data[0].id})
        }
    }, [searchStore])

    const value = useMemo(
        () => ({
            isOpen,
            onOpen: () => setIsOpen(true),
            onClose: () => setIsOpen(false),
            store,
            refreshBopisCart,
            setStore: (store) => {
                setStore(store)
                cookie.set('dw_store', store.ID)
            },
            setRefreshBopisCart,
            isLoading
        }),
        [isOpen, store, cookie]
    )

    return value
}
